import React from 'react';
import aboutProfile from '../../assets/images/aboutProfile.png';
import AboutContent from './AboutContent';
import CoolFact from './CoolFact';

const About = () => {
  return (
    <section id="about" className="bg-light-blue dark:bg-light-black  pt-28">
      <div className=" max-w-screen-xl mx-auto px-2">
        <h3
          className="section-title relative text-4xl font-black underline underline-offset-[8px] decoration-orange mb-6 dark:text-white"
          style={{ fontFamily: " 'Dancing Script', cursive" }}
        >
          About Me
        </h3>
        <div className="h-5"></div>
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div class="col-span-1">
            <div className="aboutProfile">
              <img
                src={aboutProfile}
                alt="liazul"
                className="max-w-full h-auto"
              />
            </div>
          </div>
          <div class="col-span-3">
            <AboutContent />
          </div>
        </div>
        <div className="h-16"></div>
        <CoolFact />
      </div>
    </section>
  );
};

export default About;
